export default __webpack_public_path__ + "static/0279-854ca449bcc1de882b9d83c65ffc94cf.png";